import _ from 'lodash'
import * as convert from 'util/convert'

export function emptyPutter() {
  return {
    id: "",
    label: "",
    maxPaintfillColors: 0,
    isOldSchool: false,
    restorationRequiredForStamping: false,
    frontWeightDefaultImage: "",
    rearWeightDefaultImage: "",

    faceSoleImage: "",
    faceSoleImageParameters: [],
    backCavityImage: "",
    backCavityImageParameters: [],
    playerProfileImage: "",
    playerProfileImageParameters: [],
    existingFlangeLineParameters: [],
    existingTopLineParameters: [],

    restorationType: [],
    finish: [],
    
    reshaft: [],
    length: [],
    loft: [],
    lie: [],

    paintFill: [],
    paintFillColor: [],
    paintFillLocation: [],
    translucentPaintFillColor: [],
    solidPaintFillColor: [],

    initialsLocation: [],
    stamp: [],
    stampLocation: [],
    personalizationStyle: [],

    sightDot: [],
    topLine: [],
    flangeLine: [],

    hasWeightEngraving: false,
    weightEngravingStamp: [],
    weightEngraving: [],
    weight: [],
    hasTopWeights: false,
    topWeightEngraving: [],
    topWeight: [],

    accessories: [],
    authentication: [],
    grip: [],
    gripWrap: [],
    shaftBand: [],
    headCover: [],
    buyAPutter: [],
  }
}



export function fromAPI(data) {
  // Do cleanup/manipulation of API data here
  let newData = _.chain(data)
    .toPairs()
    .map(([k, v]) => {
      if (k === 'restoration_types') { k = 'restoration_type'; }
      if (k === 'weight_engraving') { k = 'has_weight_engraving'; }
      if (k === 'weight_engravings') { k = 'weight_engraving'; }
      if (k === 'paint_fill_option') { k = 'paint_fill'; }
      if (k === 'gotta_have_it') { k = 'accessories'; }
      return [k, v];
    })
    .fromPairs()
    .value();

  newData.top_weight_engraving = newData.weight_engraving;
  newData.top_weight = newData.weight;

  //TODO: This is a dummy option which should be replaced by DB option
  // requires changes to work order form/classic form
  const doNotAuthenticate = {
      id: 99999,
      rank: 0,
      price: 0,
      discountPrice: 0,
      label: 'Do Not Authenticate',
  }  
  newData.authentication.push(doNotAuthenticate);

  //temp minPrice 
  const minPrice = 45;
  newData.minPrice = minPrice;

  return convert.objectKeysToCamelCase(newData);
}

